/* eslint react/jsx-no-literals: 0 */
import React from 'react';
import PropTypes from 'prop-types';

import {capitalize} from 'common/utils/string-util';
import {triggerWithoutParam} from 'common/utils/url-util';

import './index.scss';

export default class FilterPill extends React.Component {
  static propTypes = {
    category: PropTypes.string.isRequired,
    onClose: PropTypes.func,
    selection: PropTypes.string.isRequired,
    valueMap: PropTypes.object,
  };

  static defaultProps = {
    onClose: triggerWithoutParam,
    valueMap: {},
  };

  constructor(props) {
    super(props);

    // special labels for certain category keys
    this.categoryLabels = {
      q: 'Search',
    };
  }

  getCategoryLabel() {
    const {category, selection, valueMap} = this.props;
    return (
      this.categoryLabels[category] ||
      valueMap[category]?.[selection]?.label ||
      capitalize(category.split('-').join(' '))
    );
  }

  getValueLabel() {
    const {category, selection, valueMap} = this.props;

    return valueMap[category]?.[selection]?.displayName || selection;
  }

  render() {
    const {category, selection} = this.props;
    const categoryLabel = this.getCategoryLabel();
    const valueLabel = this.getValueLabel();
    return (
      <span className={'FilterPill'}>
        <span>{`${categoryLabel}: ${capitalize(valueLabel)}`}</span>
        <a
          className={'FilterPill--remove'}
          onClick={this.props.onClose.bind(this, category, selection)}>
          &#10005;
        </a>
      </span>
    );
  }
}
